import * as $ from "jquery";
import * as _ from "lodash";
import * as ko from "knockout";
import { Command } from "../command";
import { CommandType } from "../commandType";
import { EstimateRow } from "../state/estimateRow";
import { CostbookRow } from "../state/costbookRow";
import { EditorMode } from "../../components/estimate-cost-row-popup/estimate-cost-row-popup";
import { Application } from "../application";
import { BufferItemType } from "../buffer/bufferItemType";
import { CostbookRowType } from "../state/costbookRowType";
import { ChooseCostCommand } from "./chooseCostCommand";
import { EstimateRowType } from "../state/estimateRowType";

export class PasteRowCommand implements Command {
    constructor(private app: Application) {

    }
    type: CommandType = CommandType.PasteRow;
    canExecute = ko.computed(() => {
        let buffer = this.app.state.buffer();
        let estimate = this.app.state.estimate();
        if (!estimate) return false;
        return buffer.length > 0;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        console.log("PASTE?")
        let dfd = $.Deferred();
        let estimate = this.app.state.estimate();
        let bufferCopy = _.clone(this.app.state.buffer());
        let selectedRow = _.last<EstimateRow>(estimate!.selectedRow());
        if (selectedRow) estimate!.baseRow(selectedRow);
        this.handleBuffer(dfd);
        dfd.then(() => {            
            this.app.state.buffer(bufferCopy);
        });
        return dfd.promise();
    }

    private handleBuffer(deferred: JQueryDeferred<any>) {
        console.log("HANDLE?");
        let estimate = this.app.state.estimate();
        let bufferItem = _.first(this.app.state.buffer());
        if (!estimate) {
            deferred.reject();
            return;
        }
        if (!bufferItem) {
            deferred.reject();
            return;
        }
        let row = estimate!.baseRow();
        let promise: JQueryPromise<any> | undefined = undefined;
        switch (bufferItem.type) {
            case BufferItemType.estimateRow:
                if (!row) {
                    deferred.reject();
                    return;
                }
                let estimateRows = estimate.selectedRow();
                if (!estimateRows) {
                    deferred.reject();
                    return;
                }
                if (estimateRows.length === 0) {
                    deferred.reject();
                    return;
                }
                let attr = (<EstimateRow>bufferItem.data).attributes;
                switch ((<EstimateRow>bufferItem.data).type) {
                    case EstimateRowType.text:
                        promise = this.app.apiManager.estimateRows.saveTextRow({
                            estimateId: estimate.id(),
                            baseRowId: row.id,
                            text: attr.text
                        });
                        break;
                    case EstimateRowType.cost:
                        promise = this.app.apiManager.estimateRows.saveCostRow({
                            estimateId: estimate.id(),
                            baseRowId: row.id,
                            quantity: attr.quantity,
                            unitOfMeasure: attr.unitOfMeasure,
                            craftCode: attr.craftCode,
                            hourlyWage: attr.hourlyWage,
                            manHours: attr.manHours,
                            material: attr.material,
                            labor: attr.labor,
                            equipment: attr.equipment,
                            total: attr.total,
                        });
                        break;
                    case EstimateRowType.subtotal:
                        promise = this.app.apiManager.estimateRows.saveSubtotalRow({
                            estimateId: estimate.id(),
                            baseRowId: row.id,
                        });
                        break;
                }              
                if(promise)
                    promise.then(() => { estimate!.timestamp(new Date()); });
                break;
            case BufferItemType.costRow:
                console.log("COSTBOOK?");
                let costbookRow = <CostbookRow>bufferItem.data;
                let canInsert = false;
                switch (costbookRow.type) {
                    case CostbookRowType.section:
                        promise = this.app.commandsManager.execute(CommandType.CreateEstimateTextRow, {
                            insertAbove: false,
                            fromCostbook: true,
                        });                      
                        break;
                    case CostbookRowType.text:
                        promise = this.app.commandsManager.execute(CommandType.CreateEstimateTextRow, {
                            insertAbove: false,
                            fromCostbook: true,
                        });
                        break;
                    case CostbookRowType.aggregateCost:
                    case CostbookRowType.aggregateCostMLET:
                        let dfd = $.Deferred();
                        this.app.apiManager.costbook.getRow(costbookRow.attributes!.sectionId!, 
                            this.app.state.costbook()!.id, 
                            this.app.state.estimate()!.postalCode(),
                            this.app.state.estimate()!.equipmentAreaModApplied(),
                            this.app.state.estimate()!.laborAreaModApplied(),
                            this.app.state.estimate()!.materialAreaModApplied())
                            .done((sectionRow) => {
                                this.app.commandsManager.execute(CommandType.CreateEstimateCostRow, {
                                    editorMode: EditorMode.Advanced,
                                    insertAbove: false,
                                    fromCostbook: true,
                                    title: ChooseCostCommand.getSectionTitle(sectionRow),
                                    insertToTheEnd: bufferItem!.pasteToTheEnd,
                                })
                                    .fail(() => {
                                        dfd.reject();
                                    })
                                    .done((data) => {
                                        dfd.resolve(data);
                                    });
                            });
                        promise = dfd.promise();
                        break;
                    case CostbookRowType.equipmentCost:
                    case CostbookRowType.purchaseCost:
                    case CostbookRowType.customCost:
                    case CostbookRowType.materialCost:
                        promise = this.app.commandsManager.execute(CommandType.ChooseCost);
                        break;
                }
                if (!promise) {
                    deferred.reject();
                    return;
                }
                break;
        }
        promise!
            .then((data) => {
                this.app.state.buffer().shift();               
                let rowPromise = $.Deferred();
                if (data)
                    this.app.apiManager.estimateRows.getRow(estimate!.id(), data.id).then((rowdata) => {                        
                        estimate!.baseRow(rowdata!.data[0]);
                        estimate!.selectedRow(rowdata!.data);
                        rowPromise.resolve();
                    });
                else
                    rowPromise.resolve();
                rowPromise.then(() => {
                    if (this.app.state.buffer().length == 0) {
                        this.app.state.canUndo(data!.history.canUndo);
                        this.app.state.canRedo(data!.history.canRedo);                        
                        deferred.resolve();
                    }
                    else {
                        this.handleBuffer(deferred);
                    }
                });
            });
    }
    name = "Paste Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/pasteRowCommand.ts